import { Link } from "react-router-dom";

export default function TasksComingSoon() {
  return (
    <div className="min-h-screen relative overflow-hidden bg-white">
      {/* Background Pattern */}
      <img
        src="/waiting-lobby-pattern.svg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-50 pointer-events-none"
      />

      {/* Top Bar */}
      <div className="flex items-center justify-between px-8 py-5 border-b bg-white/80 backdrop-blur-sm">
        <Link to="/dashboard">
          <div className="flex items-center gap-3">
            <img src="/twokey-logo.svg" alt="TwoKey" className="w-8 h-8" />
            <span className="text-2xl font-allertaStencil text-[#1E1B66]">
              TWOKEY
            </span>
          </div>
        </Link>
      </div>

      {/* Main Content */}
      <div className="max-w-5xl mx-auto px-6 pt-24 text-center">
        <div className="mb-10">
          <div className="inline-flex items-center justify-center w-28 h-28 rounded-3xl bg-indigo-100">
            <svg
              width="56"
              height="56"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#4F46E5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 11l3 3L22 4" />
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
            </svg>
          </div>
        </div>

        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8">
          Tasks & Tickets
          <br />
          Coming Soon
        </h1>

        <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
          We're building a powerful productivity hub that will help your teams
          manage tasks, track tickets, collaborate across departments, and stay
          on top of every project from one central workspace.
        </p>

        {/* <p className="mt-8 text-lg text-gray-500 max-w-2xl mx-auto">
          Exciting features are currently under development. We're putting the
          finishing touches on task boards, ticket workflows, assignments,
          priorities, statuses, notifications, and team collaboration tools.
        </p> */}

        <div className="mt-14">
          <Link
            to="/dashboard"
            className="px-8 py-4 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition"
          >
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
